import { defineStore } from 'pinia';

// defineStore 调用后返回一个函数，调用该函数获得 Store 实体
export const useGlobalStore = defineStore('global', {
  // 状态
  state: () => ({
    isAcquiredPermission: false, // 是否已获取过用户权限(用户权限是在路由钩子中获取的 这个flag用于避免重复获取)
    keepAliveRouter: [] // 缓存的组件
  }),
  // 修改状态方法
  actions: {
    setAcquired(data: boolean) {
      this.isAcquiredPermission = data;
    },
    addKeepAlive(routerName: string) {
      this.keepAliveRouter.push(routerName);
    },
    removeKeepAlive(routerName: string) {
      const idx = this.keepAliveRouter.findIndex((val: string) => val === routerName);
      if (idx !== -1) {
        this.keepAliveRouter.splice(idx, 1);
      }
    },
    clearKeepAlive(data: any[]) {
      this.keepAliveRouter = data;
    }
  }
});
